import { Location } from 'graphql/generated/graphqlTypes';

export function generateMockLocation({
  doors = [],
  doorIds = [],
  id = 'mockLocationId',
  name = 'mockLocationName'
}: Partial<Omit<Location, '__typename'>>): Location {
  return {
    __typename: 'Location',
    doors,
    doorIds,
    id,
    name
  };
}
